import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Identifiable } from "../../models/Identifiable";

interface GalleryGridProps<T> {
    id: string | number;
    title: string;
    items: T[];
    isReloading?: boolean;
    loadAction?: (id: string | number) => Promise<void>;
    setReloadAction?: (state: boolean) => void;
    renderItem: (item: T) => JSX.Element;
}

export const GalleryGrid = observer(function GalleryGrid<T extends Identifiable>({ 
    id,title, items=[], isReloading, loadAction, setReloadAction, renderItem 
}: GalleryGridProps<T>) {
    // Shared loading logic
    useEffect(() => {
        if (loadAction && setReloadAction && (isReloading || items.length === 0)) {
            loadAction(id).then(() => setReloadAction(false));
        }
    }, [isReloading, items.length, loadAction, setReloadAction]);

    return (
        <section data-bs-version="5.1" className="pricing5 shopm5 cid-uATHtvPEJO" id="apricing5-4">
            <div className="position-relative">
                <div className="mbr-section-head">
                    <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                        <strong>{title}</strong>
                    </h4>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row align-items-stretch items-row justify-content-center">
                    {items.map((item) => renderItem(item))}
                </div>
            </div>
        </section>
    );
});